import { c as _c } from "react/compiler-runtime";
import { getCdnUrl } from '@morpho-org/dapp-core';
import { cn } from '@morpho-org/ui-v6/utils';
import Image from 'next/image';
import { memo } from 'react';
interface AragonDaoLabelProps {
  /** text-* class controlling the text variant (default: `text-md`). */
  textClassName?: string;
}
const AragonDaoLabel = t0 => {
  const $ = _c(6);
  const {
    textClassName: t1
  } = t0;
  const textClassName = t1 === undefined ? "text-md" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Image src={getCdnUrl("v2/assets/icons/aragon.svg")} alt="Aragon logo" width={18} height={18} />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== textClassName) {
    t3 = cn(textClassName, "text-foreground");
    $[1] = textClassName;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      whiteSpace: "nowrap"
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3) {
    t5 = <>{t2}<span className={t3} style={t4}>Aragon DAO</span></>;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
export default memo(AragonDaoLabel);